import { render, staticRenderFns } from "./NewSkillsForm.vue?vue&type=template&id=1da216b4&"
import script from "./NewSkillsForm.vue?vue&type=script&lang=js&"
export * from "./NewSkillsForm.vue?vue&type=script&lang=js&"
import style0 from "./NewSkillsForm.vue?vue&type=style&index=0&id=1da216b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports